var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cdiv class=\"presentation\" data-ng-switch=\"vm.presentationStyle\"\u003E \u003Cdiv class=\"portal field\" data-ng-switch-when=\"portal\"\u003E\u003Clabel\u003E \u003Cspan class=\"field-label\" ng-class=\"vm.isRequiredClass\"\u003E{{ vm.label }}\u003C\u002Fspan\u003E\u003Cmd-progress-linear ng-if=\"vm.validatingNumber\" md-mode=\"indeterminate\"\u003E\u003C\u002Fmd-progress-linear\u003E\u003Cng-messages for=\"vm.form[vm.localModelName].$error\" ng-show=\"vm.form[vm.localModelName].$dirty\" role=\"alert\"\u003E\u003Cng-message when=\"parsingError\"\u003EThis is not a valid {{ vm.type }}\u003C\u002Fng-message\u003E\u003Cng-message when=\"serviceAvailable\"\u003EABR service currently unavailable\u003C\u002Fng-message\u003E\u003Cng-message when=\"businessFound\"\u003EWe could not find a match for this {{ vm.type }}\u003C\u002Fng-message\u003E\u003Cng-message when=\"validEntityType\"\u003E{{ vm.validEntityTypeErrorMessage }}\u003C\u002Fng-message\u003E\u003Cng-message when=\"registrationValid\"\u003E{{ vm.type }} registration invalid\u003C\u002Fng-message\u003E\u003C\u002Fng-messages\u003E\u003Cinput name=\"{{vm.localModelName}}\" ng-model=\"vm.localModel[vm.localModelName]\" ng-change=\"vm.lookup()\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\" aria-label=\"{{ vm.label }}\" type=\"text\" ng-model-options=\"{debounce: { 'default': 500, 'blur': 0 } }\"\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"standard\" data-ng-switch-default\u003E\u003Cinput-container label=\"{{ vm.label }}\"\u003E\u003Cinput name=\"{{vm.localModelName}}\" ng-model=\"vm.localModel[vm.localModelName]\" ng-change=\"vm.lookup()\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\" aria-label=\"{{ vm.label }}\" type=\"text\" ng-model-options=\"{debounce: { 'default': 500, 'blur': 0 } }\"\u003E\u003Cmd-progress-linear ng-if=\"vm.validatingNumber\" md-mode=\"indeterminate\"\u003E\u003C\u002Fmd-progress-linear\u003E\u003Cng-messages for=\"vm.form[vm.localModelName].$error\" ng-show=\"vm.form.abn.$dirty\" role=\"alert\"\u003E\u003Cng-message when=\"parsingError\"\u003EThis is not a valid {{ vm.type }}\u003C\u002Fng-message\u003E\u003Cng-message when=\"serviceAvailable\"\u003EABR service currently unavailable\u003C\u002Fng-message\u003E\u003Cng-message when=\"businessFound\"\u003EWe could not find a match for this {{ vm.type }}\u003C\u002Fng-message\u003E\u003Cng-message when=\"registrationValid\"\u003E{{ vm.type }} registration invalid\u003C\u002Fng-message\u003E\u003C\u002Fng-messages\u003E\u003C\u002Finput-container\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;